module.exports = __webpack_public_path__ + "img/office.972acb84.png";